import { BadgeStatus } from "shared/components/StatusBadge/colorPairs";
import { Disclosure } from "@headlessui/react";
import { ChevronDown, ChevronUp } from "untitledui-js-base";
import { Checkbox } from "shared/components";

type FacetsProps = {
  title: string;
  facetController: any;
  clearSelectedRows: () => void;
};

export function Facets({
  title,
  facetController,
  clearSelectedRows
}: FacetsProps) {
  return (
    <Disclosure as="div" defaultOpen className="border-b border-alpha-80 pb-4">
      {({ open }) => (
        <>
          <Disclosure.Button className="w-full">
            <div className="flex w-full justify-between">
              <p className="text-sm font-bold text-content-1000">{title}</p>
              {open ? <ChevronUp /> : <ChevronDown />}
            </div>
          </Disclosure.Button>
          <Disclosure.Panel className="mt-4 flex flex-col gap-2">
            {facetController?.items
              .sort((a, b) => {
                if (a.label < b.label) return -1;

                if (a.label > b.label) return 1;

                return 0;
              })
              .map((item) => {
                const filterValue = BadgeStatus[item.value]
                  ? BadgeStatus[item.value]
                  : item.value;
                return (
                  <Filter
                    key={"filter" + item.label}
                    label={filterValue}
                    value={item.value}
                    clearSelectedRows={clearSelectedRows}
                    isRefined={item.isRefined}
                    refine={facetController.refine}
                  />
                );
              })}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}

type FilterProps = {
  value: string;
  label: string;
  isRefined: boolean;
  refine: (value: string) => void;
  clearSelectedRows: () => void;
};

const Filter = ({
  value,
  label,
  isRefined,
  refine,
  clearSelectedRows
}: FilterProps) => {
  return (
    <div>
      <div className="flex w-full flex-row items-center">
        <Checkbox
          onChange={() => {
            refine(value);
            clearSelectedRows();
          }}
          label={label}
          checked={isRefined}
        />
      </div>
    </div>
  );
};
